export default __webpack_public_path__ + "static/media/card-banner-budinesscycle_NFO.a5e30bed.png";